import React from "react";
import { Button, Icon } from "../../Component";

const MpClinicMetrics = ({ metrics, total, hasUser, onClinics, onTeleconsultation }) => (
  <div className="partner-overview-clinic-metrics card card-bordered mb-4">
    <div className="card-inner py-3">
      <div className="d-flex flex-wrap align-items-center justify-content-between">
        <div className="d-flex flex-wrap align-items-stretch partner-overview-clinic-metrics__tiles">
          <div className="partner-overview-clinic-metrics__tile partner-overview-clinic-metrics__tile--active">
            <span className="partner-overview-clinic-metrics__tile-label">Active</span>
            <span className="partner-overview-clinic-metrics__tile-value">{metrics.active}</span>
          </div>
          <div className="partner-overview-clinic-metrics__tile partner-overview-clinic-metrics__tile--pending">
            <span className="partner-overview-clinic-metrics__tile-label">Pending</span>
            <span className="partner-overview-clinic-metrics__tile-value">{metrics.pending}</span>
          </div>
          <div className="partner-overview-clinic-metrics__tile partner-overview-clinic-metrics__tile--default">
            <span className="partner-overview-clinic-metrics__tile-label">Default</span>
            <span className="partner-overview-clinic-metrics__tile-value">{metrics.defaultClinics}</span>
          </div>
          <div
            className="partner-overview-clinic-metrics__tile partner-overview-clinic-metrics__tile--total"
            title="Total clinics for this partner (all clinics — counts match the Clinics tab, not only the current page)."
          >
            <span className="partner-overview-clinic-metrics__tile-label">Total</span>
            <span className="partner-overview-clinic-metrics__tile-value">{metrics.total}</span>
            {total > metrics.total ? (
              <span className="partner-overview-clinic-metrics__tile-sub text-soft"> / {total} reported</span>
            ) : null}
          </div>
        </div>
        <div className="d-flex flex-wrap partner-overview-clinic-metrics__actions">
          <Button
            color="primary"
            outline
            size="sm"
            type="button"
            className="mr-1 mb-1"
            disabled={!hasUser}
            title={!hasUser ? "Link a primary user account first" : undefined}
            onClick={onClinics}
          >
            <Icon name="hospital" className="mr-1" />
            Clinics
          </Button>
          <Button
            color="info"
            outline
            size="sm"
            type="button"
            className="mb-1"
            disabled={!hasUser}
            title={!hasUser ? "Link a primary user account first" : undefined}
            onClick={onTeleconsultation}
          >
            <Icon name="video" className="mr-1" />
            Teleconsultation
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default MpClinicMetrics;
